import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { expensesInfiniteQueryOptions } from '@/hooks'
import {
  ALL_EXPENSE_CATEGORIES,
  ALL_EXPENSE_TABS,
  ALL_EXPENSE_VIEWS,
  buildExpensesAllQueryOptions,
  buildExpensesBusinessQueryOptions,
  buildExpensesReimbursementQueryOptions,
  ExpensesPage,
} from '@/pages/expenses/ExpensesPage'

const ExpensesSearchSchema = z.object({
  view: z.enum(ALL_EXPENSE_VIEWS).default('expenses'),
  tab: z.enum(ALL_EXPENSE_TABS).default('ALL'),
  businessFrom: z.iso.datetime().optional(),
  businessTo: z.iso.datetime().optional(),
  businessCategory: z.enum(ALL_EXPENSE_CATEGORIES).optional(),
  reimbursementFrom: z.iso.datetime().optional(),
  reimbursementTo: z.iso.datetime().optional(),
  reimbursementClientId: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_dashboard/expenses/')({
  validateSearch: ExpensesSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  // The page always runs all three list variants (business/reimbursement/all)
  // regardless of the active tab, so all three are prefetched here.
  loader: ({ context, deps }) =>
    Promise.all([
      context.queryClient.ensureInfiniteQueryData(
        expensesInfiniteQueryOptions(buildExpensesBusinessQueryOptions(deps.search)),
      ),
      context.queryClient.ensureInfiniteQueryData(
        expensesInfiniteQueryOptions(buildExpensesReimbursementQueryOptions(deps.search)),
      ),
      context.queryClient.ensureInfiniteQueryData(
        expensesInfiniteQueryOptions(buildExpensesAllQueryOptions()),
      ),
    ]),
  component: ExpensesPage,
})
